import { IUserModel } from "../models/userModel";

export const useUserAdditionalDetailsDialog = (user?: IUserModel) => {
  const getScheduleVisibilityTooltip = (): string => {
    if (user?.scheduleVisibilityDaysAhead) {
      return "";
    }

    const baseMessage =
      "Тъй като потребителят няма специфична настройка, се използва логиката по подразбиране. ";

    if (user?.hasActivePlan) {
      const days = user?.studioScheduleVisibilityDaysAheadForSubscribedUsers;
      return days
        ? `${baseMessage}Понеже има активен план, той вижда графика ${days} дни напред.`
        : `${baseMessage}Понеже има активен план, той вижда целия график.`;
    }

    const days = user?.studioScheduleVisibilityDaysAhead;
    return days
      ? `${baseMessage}Той вижда графика ${days} дни напред.`
      : `${baseMessage}Той вижда целия график.`;
  };

  const formatScheduleVisibilityValue = (): string => {
    return user?.scheduleVisibilityDaysAhead
      ? `${user.scheduleVisibilityDaysAhead} дни`
      : "N/A";
  };

  return {
    getScheduleVisibilityTooltip,
    formatScheduleVisibilityValue,
  };
};
